import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Navbar from './components/inc/Navbar';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Contact from './components/pages/Contact';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Navbar/>    
        <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>      
    </BrowserRouter>
    </div>
  );
}

export default App;
